<div class="formStory fl100" style="padding-top: 20px !important;">
        <!-- Web Stories Start -->
        <div class="webStoriesBlock" id="allWebStories">
          <div class="templateslist" [ngClass]="{'disable-action': !storyEditMode}">
            <ul>
              <div class="tabs tabStories">
                <span class="tablinks" (click)="fetchTemplates();activeTemplate = 'template'"
                  [class]="activeTemplate === 'template' ? 'active' : ' '" id="defaultOpenTemplate">Templates</span>
                <span id="crossDomainTemplate" *ngIf='domainList!=""' class="tablinks" (click)="fetchCrossDomainTemplates();activeTemplate = 'crossDomain'"
                  [class]="activeFeed === 'crossDomain' ? 'active' : ' '">Cross Domain</span>
  
                </div>
                <ng-container [ngSwitch]="activeTemplate">
                  <ng-container *ngSwitchCase="'template'">
                <ng-container *ngIf="templates && templates.length>0">
                    <ng-container *ngFor="let template of templates;let j = index">
                      <li tabindex="0" id="useTemplate" (click)="useTemplateWebStory(template)"><div class="template"><img src="{{template.coverImageUrl}}" alt="template"></div></li>
                    </ng-container>
                  </ng-container>
                  </ng-container>
                  <ng-container *ngSwitchCase="'crossDomain'">
                    <ng-container *ngIf="crossDomainTemplates && crossDomainTemplates.length>0">
                      <ng-container *ngFor="let template of crossDomainTemplates;let j = index">
                        <li tabindex="0" id="useTemplate" (click)="useTemplateWebStory(template)"><div class="template"><img src="{{template.coverImageUrl}}" alt="template"></div></li>
                      </ng-container>
                    </ng-container>
                    </ng-container>
                  </ng-container>
            </ul>  
          
            <div class="lightBox block lightBoxCoverImage" *ngIf="isLightboxCoverImage">
              <div class="headerLight">
                <div class="close fl spImg" (click)="closeLightBoxCoverImage()"></div>
              </div>
              <div class="lightContent">
                <div class="websiteLogo">
                  <img src="assets/images/webstories/logoHT.png">
                </div>
                <div class="uploadSection coverImage">
                  <div class="blockContain">
                    <div class="uploadimage">
                      <div class="upload-btn-wrapper">
                        <span class="btn">Upload from file</span>
                        <input accept="image/*" name="myfile" type="file">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="textBlock">
                  <label>Template Name</label>
                  <input type="text" class="textBox">
                </div>
                <div class="btnAction">
                  <button class="blue" (click)="closeLightBoxCoverImage()">Submit</button>
                </div>
              </div>
            </div> 
          </div>
          <div class="webStories"> 
            <div class="webStoryBlock">
              <div id="slides" class="webStorySlide">
                <ul class="pagination" id="pagiSlide" [dragula]="'slides-bag'" [dragulaModel]='slideIds'>
                  <ng-container *ngIf="slides && slideIds && slideIds.length>0">
                    <ng-container *ngFor="let slideId of slideIds;let j = index">
                      <ng-container *ngIf="slideId != navigationSlideId">
                        <li id="activeSlide{{slideId}}" [ngClass]="{'active':(currentSlideIndex==j)}" (click)="changeCurrentSlide(j)" [ngStyle]="setStoryHeight()"></li>
                      </ng-container>
                      <ng-container *ngIf="slideId == navigationSlideId">
                        <li id="activeSlide{{slideId}}navigation" [ngClass]="{'active':(currentSlideIndex==j)}" (click)="changeCurrentSlide(j)" [ngStyle]="setStoryHeight()"> </li>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <!--li [ngStyle]="setStoryHeight()"></li>
                  <li [ngStyle]="setStoryHeight()"></li>
                  <li [ngStyle]="setStoryHeight()"></li>
                  <li [ngStyle]="setStoryHeight()"></li-->
                </ul>
                <ul class="leftRightArrows">
                  <li tabindex="0" id="moveLeftSlide" [ngClass]="{'disable-action':(currentSlideIndex==0) || emptyWebStory}" class="leftArrow" (click)="changeToLeftRightSlide('left')"><img tabindex="0" id="moveLeftSlideImg" src="assets/images/webstories/icon-left-arrow.svg"  style="transform: scale(2,2);"></li>
                  <li tabindex="0" id="moveRightSlide" [ngClass]="{'disable-action':(currentSlideIndex==(slideIds?.length-1)) || emptyWebStory}" class="rightArrow" (click)="changeToLeftRightSlide('right')"><img tabindex="0" id="moveRightSlideImg" src="assets/images/webstories/icon-right-arrow.svg"  style="transform: scale(2,2);"></li>
                </ul>
                <ul id="templateView">
                  <ng-container *ngIf="slides && slideIds && slideIds.length>0">
                    <ng-container *ngFor="let slideId of slideIds;let j = index">
                      <li id="{{slideId}}li" [ngClass]="{'active':(currentSlideIndex==j)}" [ngStyle]="getSlideStyles(slideId)">
                        <ng-container *ngIf="currentTextboxOrButtonElements && currentTextboxOrButtonElements.length>0">
                          <ng-container *ngFor="let textboxOrButton of currentTextboxOrButtonElements;let i = index;trackBy: trackByFn">
                            <div class="textInsertion textInsertion{{i}}" id="{{slideId}}textboxOrButtonDiv{{i}}" [ngStyle]="getStyles(i)">
                              <!--span contentEditable="true">Enter text Here</span-->
                              <div id="{{slideId}}textboxOrButton{{i}}" contentEditable="{{storyEditMode}}"
                                (focus)="setTextboxOrButtonIndex($event,i)" [ngClass]="{'disable-action':!storyEditMode}"
                                (blur)="setTextboxOrButtonValue($event,i)" [innerText]="textboxOrButton.text">
                              </div>
                              <small [ngClass]="{'disable-action':!storyEditMode}" id="{{slideId}}Refresh{{i}}" tabindex="0" class="refresh" (click)="convertHTMLToPlainText(i)"><img class="content_cut" src="assets/images/webstories/refresh.svg"></small>
                              <small [ngClass]="{'disable-action':!storyEditMode}" id="{{slideId}}CopyAction{{i}}" tabindex="0" class="copyAction" contentEditable="false" (click)="copyCurrentTextboxOrButton(i)"><img class="content_cut" src="assets/images/webstories/icon-feather.svg"></small>
                              <small [ngClass]="{'disable-action':!storyEditMode}" id="{{slideId}}CloseAction{{i}}" tabindex="0" class="closeAction" contentEditable="false" (click)="removeTextboxOrButton(i)"><i class="icon-close"></i></small>
                              <small [ngClass]="{'disable-action':!storyEditMode}" id="{{slideId}}ButtonLinkAction{{i}}" tabindex="0" class="linkButton" contentEditable="false">
                                <i class="icon-link" (mouseover)="linkOptionClick(i)"></i>
                                <div id="{{slideId}}ButtonLink{{i}}" class="textBlockLink" *ngIf="linkBoxInput">
                                  <input id="{{slideId}}ButtonLinkInput{{i}}" type="text" [(ngModel)]="buttonUrl" class="textBox"
                                    placeholder="Insert URL Here" />
                                  <div id="{{slideId}}ButtonLinkDone{{i}}" class="btnBlock"><i class="icon-checkbox-tick" (click)="updateWebStoryButtonUrl(i)"></i><i class="icon-close"
                                      (click)="closeLinkOptionClick()"></i></div>
                                </div>
                              </small>
                             
                            </div>
                            
                            
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="currentNavigationSlide() && currentSlideElement.relatedStoryData && currentSlideElement.relatedStoryData.length == 1">
                          <div class="singleImg">{{currentSlideElement.relatedStoryData[0].title}}</div>
                        </ng-container>
                        <div class="linkTop" *ngIf="this.currentSlideElement.ctaText" >
                          <a class="linkTopLink">{{this.currentSlideElement.ctaText}}</a>
                          <i class="arrow up"></i>
                        </div>
                        <div class="credit" *ngIf="this.currentSlideElement.creditInfo" >
                          <a class="">{{this.currentSlideElement.creditInfo}}</a>
                        </div>
                        <div class="gradClass"></div>

                        <!--NC-27646 start -->
                        
                        <ng-container *ngIf="currentNavigationSlide() && currentSlideElement.relatedStoryData && currentSlideElement.relatedStoryData.length > 1">
                          <div class="gradClassnew"></div>
                          <div class="newgrandDiv">
                            <!-- For 4 list items -->
                            <ng-container *ngIf="currentSlideElement.relatedStoryData && currentSlideElement.relatedStoryData.length == 4">
                              <ul>
                                <li>
                                  <div class="captionDiv">
                                    <ng-container *ngIf="currentSlideElement?.relatedStoryData[0].coverImageUrl">
                                      <img
                                      src="{{currentSlideElement?.relatedStoryData[0].coverImageUrl}}">
                                    </ng-container>
                                    <span class="newcaption">
                                      <caption>{{currentSlideElement.relatedStoryData[0].title}}</caption>
                                    </span>
                                  </div>
                                </li>
                                <li>
                                  <div class="captionDiv">
                                    <ng-container *ngIf="currentSlideElement?.relatedStoryData[1].coverImageUrl">
                                      <img
                                      src="{{currentSlideElement?.relatedStoryData[1].coverImageUrl}}">
                                    </ng-container>
                                    <span class="newcaption">
                                      <caption>{{currentSlideElement.relatedStoryData[1].title}}</caption>
                                    </span>
                                  </div>
                                </li>
                          
                                <li>
                                  <div class="captionDiv">
                                    <ng-container *ngIf="currentSlideElement?.relatedStoryData[2].coverImageUrl">
                                      <img
                                      src="{{currentSlideElement?.relatedStoryData[2].coverImageUrl}}">
                                    </ng-container>
                                    <span class="newcaption">
                                      <caption>{{currentSlideElement.relatedStoryData[2].title}}</caption>
                                    </span>
                                  </div>
                                </li>
                                <li>
                                  <div class="captionDiv">
                                    <ng-container *ngIf="currentSlideElement?.relatedStoryData[3].coverImageUrl">
                                      <img
                                      src="{{currentSlideElement?.relatedStoryData[3].coverImageUrl}}">
                                    </ng-container>
                                    <span class="newcaption">
                                      <caption>{{currentSlideElement.relatedStoryData[3].title}}</caption>
                                    </span>
                                  </div>
                                </li>
                              </ul>
                            </ng-container>
                            <!-- For 2 list items -->
                            <ng-container *ngIf="currentSlideElement.relatedStoryData && currentSlideElement.relatedStoryData.length == 2">
                              <ul class="twoLi">
                                <li>
                                  <div class="captionDiv">
                                    <ng-container *ngIf="currentSlideElement?.relatedStoryData[0].coverImageUrl">
                                      <img
                                      src="{{currentSlideElement?.relatedStoryData[0].coverImageUrl}}">
                                    </ng-container>
                                    <span class="newcaption">
                                      <caption>{{currentSlideElement.relatedStoryData[0].title}}</caption>
                                    </span>
                                  </div>
                                </li>
                                <li>
                                  <div class="captionDiv">
                                    <ng-container *ngIf="currentSlideElement?.relatedStoryData[1].coverImageUrl">
                                      <img
                                      src="{{currentSlideElement?.relatedStoryData[1].coverImageUrl}}">
                                    </ng-container>
                                    <span class="newcaption">
                                      <caption>{{currentSlideElement.relatedStoryData[1].title}}</caption>
                                    </span>
                                  </div>
                                </li>
                          
                              </ul>
                            </ng-container>
                            <!-- For 3 list items -->
                            <ng-container *ngIf="currentSlideElement.relatedStoryData && currentSlideElement.relatedStoryData.length == 3">
                              <ul class="threeLi">
                                <li>
                                  <div class="captionDiv">
                                    <ng-container *ngIf="currentSlideElement?.relatedStoryData[0].coverImageUrl">
                                      <img
                                      src="{{currentSlideElement?.relatedStoryData[0].coverImageUrl}}">
                                    </ng-container>
                                    <span class="newcaption">
                                      <caption>{{currentSlideElement.relatedStoryData[0].title}}</caption>
                                    </span>
                                  </div>
                                </li>
                                <li>
                                  <div class="captionDiv">
                                    <ng-container *ngIf="currentSlideElement?.relatedStoryData[1].coverImageUrl">
                                      <img
                                      src="{{currentSlideElement?.relatedStoryData[1].coverImageUrl}}">
                                    </ng-container>
                                    <span class="newcaption">
                                      <caption>{{currentSlideElement.relatedStoryData[1].title}}</caption>
                                    </span>
                                  </div>
                                </li>
                                <li>
                                  <div class="captionDiv">
                                    <ng-container *ngIf="currentSlideElement?.relatedStoryData[2].coverImageUrl">
                                      <img
                                      src="{{currentSlideElement?.relatedStoryData[2].coverImageUrl}}">
                                    </ng-container>
                                    <span class="newcaption">
                                      <caption>{{currentSlideElement.relatedStoryData[2].title}}</caption>
                                    </span>
                                  </div>
                                </li>
                              </ul>
                            </ng-container>
                          </div>
                        </ng-container>
                        <!--NC-27646 end -->
                        

                        <div id="{{slideId}}logo{{i}}" *ngIf="currentSlideElement?.hasLogoImage && currentSlideElement?.logoUrl" class="slideLogo" [ngStyle]="getStylesLogo()" [ngClass]="{'disable-action':!storyEditMode}">
                          <span class="closeAction" (click)="removeLogo()"><i class="icon-close"></i></span>
                          <img src="{{currentSlideElement?.logoUrl}}">
                        </div>
                        <div class="videoContainer" id="{{slideId}}video{{i}}" *ngIf="currentSlideElement?.hasSlideVideo && currentSlideElement?.video && currentSlideElement?.video?.url">
                          <video width="100%" height="100%" src="{{currentSlideElement?.video.url}}" type="video/mp4" controls>
                            Your browser does not support the video tag.
                          </video>
                          
                        </div>
                      </li>
                    </ng-container>
                    
                  </ng-container>
                  <li class="active" *ngIf="emptyWebStory">
                    <button class="createSlideBtn" (click)="createFirstslide()">Create First Slide</button>
                  </li>

                  <!--li>Template 1</li>
                  <li class="active">Template 2
                    <ng-container *ngIf="currentTextboxOrButtonElements">
                      <ng-container *ngFor="let textboxOrButton of currentTextboxOrButtonElements;let i = index">
                        <div class="textInsertion">
                          <span id="textboxOrButton{{i}}" contentEditable="true" (blur)="setTextboxOrButtonValue($event,i)">{{textboxOrButton.text}}</span>
                        </div>
                      </ng-container>
                    </ng-container>
                  </li>
                  <li>Template 3</li>
                  <li>Template 4</li-->
                </ul>
              </div>
              <div class="webStoryAction" [ngClass]="{'disable-action':emptyWebStory || !storyEditMode}">
                <ul [ngClass]="currentNavigationSlide()?'disable-field':'enable-field'">
                  <li class="parent_right" tabindex="0" id="addTextbox" (click)="insertTextboxOrButton()" [ngClass]="{'disable-action':currentNavigationSlide()}"><samp class="expdMsg_right">Add Text</samp><img src="assets/images/webstories/material-text-fields.svg"></li>
                  <li class="parent_right_large" tabindex="0" id="addImage" (click)="insertImage()" [ngClass]="{'disable-action':currentNavigationSlide()}"><samp class="expdMsg_right_large">Add Image/Gif<br>
                    Adding an Image/Gif without removing the current media will create a new slide<br>
                    Adding multiple images will create multiple slides
                    </samp><img src="assets/images/webstories/feather-image.svg"></li>
                  <li class="parent_right_mid" tabindex="0" id="addvideo" (click)="insertVideo()" [ngClass]="{'disable-action':currentNavigationSlide()}"><samp class="expdMsg_right_mid">Add Video<br>
                    Adding an Video without removing the current media will create a new slide
                    </samp><img src="assets/images/webstories/feather-video.svg"></li>
                  <!-- <li><img src="assets/images/webstories/wetherstory.svg"></li>    -->
                  <li class="parent_right" tabindex="0" id="deleteImageVideo" (click)="deleteVideoAndImage()" [ngClass]="{'disable-action':currentNavigationSlide()}"><samp class="expdMsg_right">Delete Image/Gif/Video</samp><img src="assets/images/webstories/trash.svg"></li>
                  <li class="parent_right" tabindex="0" id="copyText" (click)="pasteCopiedCurrentTextboxOrButton()" [ngClass]="{'disable-action':currentNavigationSlide()}"><samp class="expdMsg_right">Paste copied text box</samp><img class="content_paste" src="assets/images/webstories/content_paste.svg"></li>
                  <li *ngIf="enableNavigationSlide" class="parent_right" tabindex="0" id="addNavigationSlide" (click)="openRelatedStoryPopup()" [ngClass]="{'disable-action':currentNavigationSlide()}"><samp class="expdMsg_right">Add Navigation Slide</samp><img class="content_paste" src="assets/images/webstories/addNav.png"></li>
                  <li *ngIf="enableAffiliateLink" class="parent_right" tabindex="0" id="addAffiliateLink" (click)="openAmazonAdSearchPopup()"><samp class="expdMsg_right">Add Affiliate link</samp><img src="assets/images/webstories/affiliate.png" width="20" height="20"></li>
                </ul>
              </div>
            </div>
            <div class="bottomCallAction" [ngClass]="{'disable-action':emptyWebStory || !storyEditMode}">
              <ul [ngClass]="currentNavigationSlide()?'disable-field':'enable-field'">
                <li class="parent_top" tabindex="0" id="addLeftSlide" (click)="insertSlideOnLeft()" [ngClass]="'enable-field'"><samp class="expdMsg">Add Slide before</samp><img src="assets/images/webstories/add-circle-outline.svg"></li>
                <li class="parent_top" tabindex="0" id="deleteSlide" (click)="deleteCurrentSlide()" [ngClass]="'enable-field'"><samp class="expdMsg">Delete Slide</samp><img src="assets/images/webstories/trash.svg"></li>
                <!-- <li><img src="assets/images/webstories/feather-play-crcle.svg"></li> -->
                <li class="parent_top" tabindex="0" id="copySlide" (click)="insertDuplicateSlideOnRight()" [ngClass]="{'disable-action':currentNavigationSlide()}"><samp class="expdMsg">Duplicate Slide</samp><img src="assets/images/webstories/icon-feather.svg"></li>
                <li class="parent_top" tabindex="0" id="addRightSlide" (click)="insertSlideOnRight()" [ngClass]="{'disable-action':currentNavigationSlide()}"><samp class="expdMsg">Add Slide after</samp><img src="assets/images/webstories/add-circle-outline.svg"></li>
              </ul>
            </div>

          </div>
        </div>
        <div class="lightPopImage block" *ngIf="imageEnabled">
        <div class="uploadMedia">
          <div class="heading">
            <h3>Upload Image</h3>
            <span class="closeIcon" (click)='clsoeImage()'><i class="icon-close"></i></span>
          </div>
          <div class="uploadSection">
            <div class="blockContain">
              <div class="uploadimage">
                <div class="upload-btn-wrapper">
                  <span class="btn">Upload from file</span>
                  <!--input type="file" name="myfile" accept="image/*"  /-->
                  <input type="file" accept="image/*" name="myfile" (change)="onFileChange($event,'slideImage')" multiple/>
                </div>
              </div>
              <div class="pickimage">
                <span (click)="showGallery('slideImage')" class="pickimageBtn">Pick from Image Library</span>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div class="lightPopImage block" *ngIf="coverImageEnabled">
          <div class="uploadMedia">
            <div class="heading">
              <h3>Upload Cover Image</h3>
              <span class="closeIcon" (click)='closeCoverImage()'><i class="icon-close"></i></span>
            </div>
            <div class="uploadSection">
              <div class="blockContain">
                <div class="uploadimage">
                  <div class="upload-btn-wrapper">
                    <span class="btn">Upload from file</span>
                    <!--input type="file" name="myfile" accept="image/*"  /-->
                    <!--input type="file" accept="image/*" name="myfile" (change)="onFileChange($event)"/-->
                    <input id="addCoverImage" accept="image/*" name="myfile" type="file" (change)="onFileChange($event,'coverImage')">
                  </div>
                </div>
                <div class="pickimage">
                  <span (click)="showGallery('coverImage')" class="pickimageBtn">Pick from Image Library</span>
                </div>
              </div>
            </div>
          </div>
          </div>
        <div class="lightPopVideo block" *ngIf="videoEnabled">
          <div class="uploadMedia">
            <div class="heading">
              <h3>Upload Video</h3>
              <span class="closeIcon" (click)='closeVideo()'><i class="icon-close"></i></span>
            </div>
            <div class="uploadSection">
              <div class="blockContain">
                <div class="uploadimage">
                  <div class="upload-btn-wrapper">
                    <span class="btn">Upload from file</span>
                    <input type="file" name="myfile" accept="video/*" (change)="onVideoFileChange($event)" />
                  </div>
                </div>
                <div class="pickimage">
                  <span class="pickimageBtn" (click)="showVideoGallery()">Pick from Video Library</span>
                </div>
              </div>
            </div>
          </div>
          </div>
</div>

<ng-container *ngIf="enableLoader || uploadImageInProgress">
  <div class="block">
    <div class="lightContent">
  <div class="imagepreloader">
    <div class="a" style="--n: 5;">
      <div class="dot dot1" style="--i: 0;"></div>
      <div class="dot dot2" style="--i: 1;"></div>
      <div class="dot dot3" style="--i: 2;"></div>
      <div class="dot dot4" style="--i: 3;"></div>
    </div>
  </div>
  </div>
  </div>
</ng-container>

<!--div class="lightBox block" *ngIf="isLightbox">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableshowGallery()"></div>
  </div>
  <div class="web-story-image" [photogalleryId]="false" (emitIdfn)="getLeadMediaId($event, true)"
    *ngIf="isPhotopopup"></div>
</div-->

<!--div class="lightBox block lightBoxVideo" *ngIf="isLightboxVideo">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableshowVideoGallery()"></div>
  </div>
  <div class="lightContent">
    <div class="listing" pageId="slideVideoListing"
      allApi="video_stories"
      searchApi="video_search"
      videoListing = "true"
      [showPagination]="true"
      [videogallery]="true"
      metaApi="" (sendIdVieoToParentfn)="getVideo($event)"
      search_label="Search Videos...">
    </div>
  </div>
</div-->

<div class="lightBox block lightBoxVideo" *ngIf="isLightboxVideo">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableshowVideoGallery()"></div>
  </div>
  <div class="lightContent">
      <div class="imageLibrary">
          <div class="listing"
            [pageId]="'slideVideoListing'"
            [allApi]="'video_stories'"
            [searchApi]="'video_search'"
            [metaApi]="'photo_meta'"
            [ImageArray]="listImageArray"
            photoListing="true"
            [showPagination]="false"
            [photogallery]="false"
            (sendIdToParentfn)="getVideoElementId($event)"
            [exclusionList]="exclusionList"
            search_label="Search videos...">
          </div>
      </div>
  </div>
</div>

<div class="lightBox block" *ngIf="isLightbox">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableshowGallery()"></div>
  </div>
  <div class="lightContent" *ngIf="isPhotopopup">
    <div class="headingPage">
      
      <h2 class="tablinks all_stories"  (click)="showAllStory = true;showMyWorkSpace = false;showNonWeb = false;showPixabay=false"
      [class]="showAllStory ? 'active' : ' '" id="defaultOpen1">Web Story</h2>
      <h2 *ngIf="internalImageList" class="tablinks all_stories"  (click)="showAllStory = false;showMyWorkSpace = false;showNonWeb = true;showPixabay=false"
      [class]="showNonWeb ? 'active' : ' '" id="defaultOpen2">Internal</h2>
      <h2 *ngIf="wireImageList" class="tablinks all_stories"  (click)="showAllStory = false;showMyWorkSpace = true;showNonWeb = false;showPixabay=false"
      [class]="showMyWorkSpace ? 'active' : ' '" id="defaultOpen3">Wires</h2>
      <h2 *ngIf="enablePixabay" class="tablinks all_stories"  (click)="showAllStory = false;showMyWorkSpace = false;showPixabay = true;showNonWeb = false"
      [class]="showPixabay ? 'active' : ' '" id="defaultOpen4">Pixabay</h2>
    </div>
    <div id="allStories" [style.display] = "showAllStory ? 'block' : 'none'" style="display: block;">
      <div class="imageLibrary">
        
          <div *ngIf="imageType=='slideImage'" class="listing webStoryslidePhotoListing"
            [pageId]="'slidePhotoListing'"
            [allApi]="'photolist'"
            [searchApi]="'photolist'"
            [metaApi]="'photo_meta'"
            [ImageArray]="listImageArray"
            photoListing="true"
            [showPagination]="false"
            [photogallery]="true"
            (sendIdToParentfn)="getMediaId($event)"
            [exclusionList]="exclusionList"
            search_label="Search Photo Library...">
          </div>

          <div *ngIf="imageType=='coverImage'" class="listing webStoryslidePhotoListing"
            [pageId]="'slidePhotoListing'"
            [allApi]="'photolist'"
            [searchApi]="'photolist'"
            [metaApi]="'photo_meta'"
            [ImageArray]="listImageArray"
            photoListing="true"
            [showPagination]="false"
            [photogallery]="false"
            (sendIdToParentfn)="getLeadMediaId($event)"
            [exclusionList]="exclusionList"
            search_label="Search Photo Library...">
          </div>
      </div>
    </div>
    <div id="nonwebStories" [style.display] = "showNonWeb ? 'block' : 'none'" style="display: block;">
      <div class="imageLibrary">
        <div *ngIf="imageType=='slideImage'" class="listing webStoryslidePhotoListing" 
          [pageId]="'photoListing'"
          [allApi]="'photolist'" 
          [searchApi]="'photolist'" 
          [metaApi]="'photo_meta'" 
          [ImageArray]="listImageArray"
          photoListing="true" 
          [showPagination]="false"
          [photogallery]="true" 
          (sendIdToParentfn)="getMediaId($event)" 
          [exclusionList]="exclusionList"
          search_label="Search Photo Library...">
        </div>

        <div *ngIf="imageType=='coverImage'" class="listing webStoryslidePhotoListing"
          [pageId]="'photoListing'"
          [allApi]="'photolist'" 
          [searchApi]="'photolist'" 
          [metaApi]="'photo_meta'" 
          [ImageArray]="listImageArray"
          photoListing="true" 
          [showPagination]="false"
          [photogallery]="false" 
          (sendIdToParentfn)="getLeadMediaId($event)" 
          [exclusionList]="exclusionList"
          search_label="Search Photo Library...">
        </div>
      </div>
    </div>
    <div id="wireStories" [style.display] = "showMyWorkSpace ? 'block' : 'none'" style="display: block;">
      <div class="imageLibrary">
        <div *ngIf="imageType=='slideImage'" class="listing webStoryslidePhotoListing"
          [pageId]="'wirephotoListing'"
          [allApi]="'wirephotolist'"
          [searchApi]="'wiresearch_photo'"
          [metaApi]="'wirephoto_meta'"
          [ImageArray]="listImageArray"
          photoListing="true"
          [showPagination]="false"
          [photogallery]="true"
          (sendIdToParentfn)="getMediaId($event,'wire')"
          [exclusionList]="exclusionList"
          search_label="Search Wire Photos...">
        </div>

        <div *ngIf="imageType=='coverImage'" class="listing webStoryslidePhotoListing"
          [pageId]="'wirephotoListing'"
          [allApi]="'wirephotolist'"
          [searchApi]="'wiresearch_photo'"
          [metaApi]="'wirephoto_meta'"
          [ImageArray]="listImageArray"
          photoListing="true"
          [showPagination]="false"
          [photogallery]="false"
          (sendIdToParentfn)="getLeadMediaId($event,'wire')"
          [exclusionList]="exclusionList"
          search_label="Search Wire Photos...">
        </div>
      </div>
    </div>

    <div id="wireStories" [style.display] = "showPixabay ? 'block' : 'none'" style="display: block;">
      <div class="imageLibrary">
        <div *ngIf="imageType=='slideImage'" class="listing webStoryslidePhotoListing"
        [pageId]="'pixabayListing'"
        [allApi]="'pixabaylist'"
        [searchApi]="'pixabaylist_search'"
        [ImageArray]="listImageArray"
        photoListing="true"
        [photogallery]="true"
        [showPagination]="false"
        [photogallery]="showPhotogallery"
        (sendIdToParentfn)="getMediaId($event,'pixabayListing')"
        search_label="Search Photos...">
      </div>

      <div *ngIf="imageType=='coverImage'" class="listing webStoryslidePhotoListing"
      [pageId]="'pixabayListing'"
      [allApi]="'pixabaylist'"
      [searchApi]="'pixabaylist_search'"
      [ImageArray]="listImageArray"
      photoListing="true"
      [photogallery]="false"
      [showPagination]="false"
      [photogallery]="showPhotogallery"
      (sendIdToParentfn)="getLeadMediaId($event,'pixabayListing')"
      search_label="Search Photos...">
    </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="showCropper && showCropper.length>0 && !isAIimge">
<ng-container *ngFor="let cropper of  showCropper;let j = index">
<ng-container *ngIf="imageType!='coverImage'">
  <div id="cropper{{j}}" class="image-cropper" *ngIf="cropper.crop" [cropperImageUrl]="cropper.cropperImageUrl" [storyType]="webStory.type"
  (finish)="finishCropping($event,j)" [parentId]="cropper.parentId" (cancel)="cancelCropping($event,j)" [isImageLead]="true" [verticalImageFlag]="false" [explicitCropperUrls]="cropperUrls"></div>
</ng-container>
<ng-container *ngIf="imageType=='coverImage'">
  <div id="cropper{{j}}" class="image-cropper" *ngIf="cropper.crop" [cropperImageUrl]="cropper.cropperImageUrl" [storyType]="webStory.type"
  (finish)="finishCropping($event,j)" [parentId]="cropper.parentId" (cancel)="cancelCropping($event,j)" [isImageLead]="true" [verticalImageFlag]="false"></div>
</ng-container>
</ng-container>
</ng-container>

<ng-container *ngIf="showCropper && showCropper.length>0">
  <ng-container *ngFor="let cropper of  showCropper;let j = index">
  <ng-container *ngIf="isAIimge">
    <div id="cropper{{j}}" class="image-cropper" *ngIf="cropper.crop" [cropperImageUrl]="cropper.cropperImageUrl" [storyType]="webStory.type"
    (finish)="finishCropping1($event,j)" (cancel)="cancelCropping($event,j)" [isImageLead]="true" [verticalImageFlag]="false" [explicitCropperUrls]="cropperUrls"></div>
  </ng-container>
  </ng-container>
  </ng-container>

<div [class]="showRelatedStoryPopup ? 'lightBox listrelatedstories block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="closeRelatedStoryModal(null)"></div>
  </div>
  <div class="related-story-listing" [chooseMultiple]="true" (sendIdListToParentfn)="getRelatedStoryIds($event)" (closePopupEmit)="closeRelatedStoryModal($event)" 
  (sendRelatedStoryData)="getRelatedStoryData($event)" [exclusionList]="relatedStoryTempList" *ngIf="showRelatedStoryPopup" [storyId]="storyId" [relatedStoryType]="relatedStoryType"></div>
</div>
<div class="lightBox listrelatedstories affiliateListing listTableElements listingFour block" *ngIf="amazonAdSearchPopup">
  <div class="headerLight">
    <!-- <div class="close fl spImg" (click)="openCloseAmazonAdSearchPopup(false)"></div> -->
  </div>
  <div class="app-affiliate-listing" [amazonOrSnapdeal]="'affiliate'" [chooseMultiple]="false" (sendIdListToParentfn)="getAmazonEmbedStoryIds($event)"
    (closePopupEmit)="closeAmazonAdSearchPopup($event)"  [storyId]="webStory.id"
    ></div>
  <!-- <div class="app-affiliate-listing" (elementSelection)="addElementToStory($event)" [elementType]="'embed,amazonMeta:true'"
    (closePopupEmit)="openCloseAmazonAdSearchPopup($event)" [chooseMultiple]="relatedStoryMultipleSelectFlag"></div> -->
</div>

<!-- <div class="thirdContainScroll">
  <div class="thirdContainer marb20">
    <div class="tabs tabStories">
      <span class="tablinks metadata " (click)="snowplowAnalytics('Metadata');activeFeed = 'metadata'"
        [class]="activeFeed === 'metadata' ? 'active' : ' '" id="defaultOpen">Metadata</span>
      <span class="tablinks design" (click)="snowplowAnalytics('Design');activeFeed = 'design'"
        [class]="activeFeed === 'design' ? 'active' : ' '">Design</span>
      <span class="tablinks animation" (click)="snowplowAnalytics('Animation');activeFeed = 'animation'"
        [class]="activeFeed === 'animation' ? 'active' : ' '">Animation</span>
    </div>
    <ng-container [ngSwitch]="activeFeed">
      <ng-container *ngSwitchCase="'metadata'">
        <div class="tabcontent" id="allStories" style="display: block;">
          <div class="preview padb20 fl100">Preview
            <span class="right fr">
              <a href="#">
                <span class="molineLink">
                  <i class="icon-mobile"></i>Mobile</span>
              </a>
              <a href="#">
                <span class="desktopLink">
                  <i class="icon-desktop"></i>Desktop</span>
              </a>
            </span>
          </div>
          <div class="tabcontent" id="meta">
            <div class="usermeta blocks marb20">
              <div class="head">Metadata</div>
              <div class="form">
                <ul class="bylineBlock">
                  <li>
                    <label>By Line</label>
                    <div class="dataField">
                      <ul class="tagit ui-widget ui-widget-content ui-corner-all" id="myTags">
                          <li class="tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable">
                            <span class="tagit-label">Giridhar Raj</span>
                              <a class="tagit-close">
                              <span class="text-icon">×</span>
                                <span class="ui-icon ui-icon-close"></span>
                              </a>
                              <input class="tagit-hidden-field" name="tags" type="hidden" value="fsbbfb">
                          </li>
                          <li class="tagit-new">
                            <input class="textBox" type="text" placeholder="Add Byline here..">  
                          </li>
                        </ul>
                    </div>
                  </li>
                  <li>
                    <span class="more spImg_story">
                      more
                    </span>
                  </li>
                </ul>
                <ul>
                  <li>
                    <label>Agency</label>
                    <div class="dataField">
                      <input class="textBox" placeholder="Add Agency here." type="text">
                          <div class="autosuggestion block">
                            <ul>
                              <li>
                                <span class="name">No Results</span>
                              </li>
                            </ul>
                          </div>
                    </div>
                  </li>
                  <li>
                    <label>
                      Section
                    </label>
                    <div class="dataField">
                      <input class="textBox" placeholder="Add Section here." type="text">
                    </div>
                  </li>
                  <li>
                    <label>Sub-section
                    </label>
                    <div class="dataField">
                      <input class="textBox" placeholder="Add SubSection here." type="text">
                    </div>
                  </li>
                  <li>
                    <label>Topic</label>
                    <div class="dataField">
                        <input class="textBox" type="text" placeholder="Enter text to search Topics..">
                      </div>
                  </li>
                  <li>
                    <label>Keywords</label>
                    <div class="dataField">
                      <input class="textBox" type="text" placeholder="Add keywords here..">            
                    </div>
                  </li>
                  <li>
                    <label>Tags</label>
                    <div class="dataField">
                        <input class="textBox" type="text" placeholder="Add Tags here..">
                      <p class="moretags">
                        <a>get tags</a>
                      </p>
                    </div>
                  </li>
                  <li>
                    <label>Source</label>
                    <div class="dataField">
                        <label class="radioBlock">
                            <input name="options" type="radio">
                            <span class="radiomark"></span>
                            Digital
                        </label><label class="radioBlock">
                            <input name="options" type="radio">
                            <span class="radiomark"></span>
                            Print
                        </label><label class="radioBlock">
                            <input name="options" type="radio">
                            <span class="radiomark"></span>
                            Agency
                        </label>
                    </div>
                  </li>
                  <li>
                    <label>Location</label>
                    <div class="dataField">
                        <input class="textBox" type="text" placeholder="Add Location here..">
                    </div>
                  </li>
                  <li>
                    <label>Canonical URL</label>
                    <div class="dataField">
                      <input class="textBox" placeholder="Add Canonical URL here" type="text">
                    </div>
                  </li>
                  <li>
                    <label>External URL</label>
                    <div class="dataField">
                      <input class="textBox" placeholder="Add External URL here" type="text">
                    </div>
                  </li>
                  <li>
                    <label>Big Story</label>
                    <div class="dataField">
                      <label class="switch" tabindex="0">
                        <input type="checkbox">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <label>Breaking News</label>
                    <div class="dataField">
                      <label class="switch" tabindex="0">
                        <input type="checkbox">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <label>Sponsored</label>
                    <div class="dataField">
                      <label class="switch" tabindex="0">
                        <input type="checkbox">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <label>Mark UnImportant</label>
                    <div class="dataField">
                      <label class="switch" tabindex="0">
                        <input type="checkbox">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <label>Live</label>
                    <div class="dataField">
                      <label class="switch" tabindex="0">
                        <input type="checkbox">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <label>Developing</label>
                    <div class="dataField">
                      <label class="switch" tabindex="0">
                        <input type="checkbox">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <label>Interview</label>
                    <div class="dataField">
                      <label class="switch" tabindex="0">
                        <input type="checkbox">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <label>Specials</label>
                    <div class="dataField">
                      <label class="switch" tabindex="0">
                        <input type="checkbox">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <label>In-Depth</label>
                    <div class="dataField">
                      <label class="switch" tabindex="0">
                        <input type="checkbox">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <label>Opinion</label>
                    <div class="dataField">
                      <label class="switch" tabindex="0">
                        <input type="checkbox">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <label>Latest</label>
                    <div class="dataField">
                      <label class="switch" tabindex="0">
                        <input type="checkbox">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <label>Fact Check</label>
                    <div class="dataField">
                      <label class="switch" tabindex="0">
                        <input type="checkbox">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <label>Premium Story</label>
                    <div class="dataField">
                      <label class="switch" tabindex="0">
                        <input type="checkbox">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
      </div>
      </ng-container>
      <ng-container *ngSwitchCase="'design'">
        <div class="tabcontent" id="design" style="display: block;">
          <div class="designBlock">
            <label>Alignment</label>
            <div class="alignment">
              <ul>
                <li><img src="assets/images/webstories/icon-1.svg"></li>
                <li><img src="assets/images/webstories/icon-2.svg"></li>
                <li><img src="assets/images/webstories/icon-3.svg"></li>
                <li><img src="assets/images/webstories/icon-4.svg"></li>
                <li><img src="assets/images/webstories/icon-5.svg"></li>
                <li><img src="assets/images/webstories/icon-6.svg"></li>
                <li><img src="assets/images/webstories/icon-7.svg"></li>
                <li><img src="assets/images/webstories/icon-8.svg"></li>
              </ul>
              <div class="alignOption">
                <div class="alignWH">
                  <ul>
                    <li>W<input type="text" class="textBox"></li>
                    <li>H<input type="text" class="textBox"></li>
                  </ul>
                </div>
                <div class="alignXY">
                  <ul>
                    <li>X<input type="text" class="textBox"></li>
                    <li>Y<input type="text" class="textBox"></li>
                  </ul>
                </div>
                <div class="alignRotation">
                  <ul>
                    <li>R<input type="text" class="textBox"></li>  
                    <li>&nbsp;</li> 
                  </ul>
                </div>
              </div>
            </div>
            <label>Text</label>
            <div class="textBlock">
              <div class="dataField">
                <select>
                  <option>Montserrat</option>
                  <option>Montserrat Font 2</option>
                  <option>Montserrat Font 3</option>
                  <option>Montserrat Font 4</option>
                  <option>Montserrat Font 5</option>
                </select>
              </div>
              <div class="dataField">
                <div class="fontSize">
                  <select>
                    <option>14</option>
                    <option>15</option>
                    <option>16</option>
                    <option>17</option>
                    <option>18</option>
                  </select>
                </div>
                <div class="fontWeight">
                  <select>
                    <option>Light</option>
                    <option>Mediam</option>
                    <option>Bold</option>
                    <option>Bolder</option>
                  </select>
                </div>
              </div>
              <div class="dataField">
                <div class="alignBlock">
                  <ul>
                    <li><img src="assets/images/webstories/leftalign.svg"></li>
                    <li><img src="assets/images/webstories/centeralign.svg"></li>
                    <li><img src="assets/images/webstories/rightalign.svg"></li>
                  </ul>
                </div>
                <div class="fontStyleBlock">
                  <ul>
                    <li><img src="assets/images/webstories/TT1.svg"></li>
                    <li><img src="assets/images/webstories/TT2.svg"></li>
                    <li><img src="assets/images/webstories/TT3.svg"></li>
                    <li><img src="assets/images/webstories/TT4.svg"></li>
                    <li><img src="assets/images/webstories/TT5.svg"></li>
                  </ul>
                </div>
              </div>
              <div class="dataField">
                <div class="colorBox">
                  <div class="fontColor">
                    <ul>
                      <li>
                        <label class="checkblock" tabindex="0">
                          <input type="checkbox">
                          <span class="checkmark"></span>
                        </label>
                    </li>
                      <li><span class="color" style="background: #000000;"></span></li>
                      <li>Font Color</li>
                      <li><img src="assets/images/webstories/icon-md-color-filter.svg"></li>
                    </ul>
                  </div>
                  <div class="borderColor">
                    <ul>
                      <li>
                        <label class="checkblock" tabindex="0">
                          <input type="checkbox">
                          <span class="checkmark"></span>
                        </label>
                      </li>
                      <li><span class="color" style="background: #53C17D;"></span></li>
                      <li>Border Color</li>
                      <li><img src="assets/images/webstories/icon-md-color-filter.svg"></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <label>Border Style</label>
            <div class="borderBlock">
            <div class="dataField">
              <div class="borderWeight">
                <select>
                  <option>Solid</option>
                  <option>Dashed</option>
                  <option>Dotted</option>
                </select>
              </div>
            </div>
            <div class="dataField">
              <div class="borderBox">
                  <ul>
                    <li><img src="assets/images/webstories/border1.svg"></li>
                    <li><img src="assets/images/webstories/border2.svg"></li>
                    <li><img src="assets/images/webstories/border3.svg"></li>
                    <li><img src="assets/images/webstories/border4.svg"></li>
                    <li><img src="assets/images/webstories/border5.svg"></li>
                  </ul>
              </div>  
            </div>
            </div>
            <label>Corner Radius</label>
          </div>
      </div>
      </ng-container>
      <ng-container *ngSwitchCase="'animation'">
        <div class="tabcontent" id="animation" style="display: block;">
          <div class="animationBlock">
            <label>Effect</label>
            <div class="dataField">
              <select>
                <option>None</option>
                <option>Fade In</option>
                <option>Fade Out</option>
                <option>Ease In</option>
                <option>Ease Out</option>
              </select>
            </div>
          </div>
      </div>
      </ng-container>
    </ng-container>
  </div>
</div> -->
